var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#1DA687"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77267 15.2958C7.66661 15.2958 7.56449 15.2767 7.46631 15.2385C7.36752 15.201 7.28024 15.1443 7.20449 15.0685L3.40903 11.2731C3.27267 11.1367 3.20812 10.9737 3.2154 10.784C3.22327 10.5949 3.28782 10.4322 3.40903 10.2958C3.5454 10.1594 3.70843 10.0913 3.89812 10.0913C4.08721 10.0913 4.24237 10.1594 4.36358 10.2958L7.77267 13.7049L15.6363 5.84126C15.7575 5.7049 15.9166 5.63672 16.1136 5.63672C16.3105 5.63672 16.4696 5.7049 16.5909 5.84126C16.7272 5.97763 16.7954 6.14036 16.7954 6.32945C16.7954 6.51914 16.7272 6.68217 16.5909 6.81854L8.34085 15.0685C8.26509 15.1443 8.17812 15.201 8.07994 15.2385C7.98115 15.2767 7.87873 15.2958 7.77267 15.2958Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/Check box.f4a1186b0da4eb8fce99f6d345bf266d.svg";
export { ForwardRef as ReactComponent };